// extracted by mini-css-extract-plugin
export default {"news":"index_news_GFapH","time":"index_time_oE0jD","title":"index_title_fYrSq"};